export const MOTOROLA = {
  id: "motorola",
  name: "MOTOROLA SOLUTIONS",
  imageFolder: "/motorola",
  tagline: {
    pt: "Sistemas MOTOTRBO de rádio profissional para comunicações críticas.",
    en: "Professional MOTOTRBO radio systems for mission-critical communications.",
    es: "Sistemas MOTOTRBO de radio profesional para comunicaciones críticas.",
  },
  color: "#0055A4",
  theme: {
    bgGradient: "from-[#eef2fa] via-[#d8e8f5] to-[#d6e6f2]",
    blob1: "bg-blue-300/30",
    blob2: "bg-indigo-200/40",
    overlineText: "text-blue-700",
    pillarPill: "border-blue-400 text-blue-700",
    segmentHover: "hover:border-blue-400",
    tabHover: "hover:border-blue-400 hover:text-blue-700",
    ctaPrimary:
      "bg-blue-700 hover:bg-blue-800 shadow-blue-700/25 hover:shadow-blue-700/40",
    ctaOutline: "border-blue-400 text-blue-700 hover:bg-blue-50",
    productHover: "hover:border-blue-400",
    productQuoteCta: "border-blue-400 text-blue-700 hover:bg-blue-50",
    productBadge: "text-blue-700",
    productPreviewPill: "text-blue-700",
    whyPanel: "border-blue-200 from-blue-50 to-white",
    whyItemBorder: "border-blue-100",
    whyCheck: "text-blue-600",
    modalHeaderBg: "from-blue-50 via-[#d8e8f5] to-indigo-50",
    modalBrandBadge: "border-blue-200 text-blue-700",
    modalInputFocus: "focus:border-blue-500 focus:ring-blue-500/20",
    modalSubmit:
      "bg-blue-700 hover:bg-blue-800 shadow-blue-700/25 hover:shadow-blue-700/40",
  },
  pillars: {
    pt: ["APX P25", "MOTOTRBO", "Capacity Max"],
    en: ["APX P25", "MOTOTRBO", "Capacity Max"],
    es: ["APX P25", "MOTOTRBO", "Capacity Max"],
  },
  segments: {
    pt: [
      { name: "Indústria", desc: "Comunicação robusta em fábricas, linhas de produção e áreas de armazenagem." },
      { name: "Logística", desc: "Cobertura fiável em armazéns, pátios e operações de transporte." },
      { name: "Mineração", desc: "Sistemas críticos em ambientes extremos e locais remotos." },
      { name: "Segurança Privada", desc: "Equipas de vigilância e resposta rápida sempre ligadas." },
      { name: "Hotelaria", desc: "Comunicação discreta entre departamentos para serviço de excelência." },
      { name: "Serviços Públicos", desc: "Utilities e infraestruturas críticas com rádio trunking seguro." },
      { name: "Eventos", desc: "Coordenação de staff e produção em grandes recintos." },
    ],
    en: [
      { name: "Industry", desc: "Rugged communication across factories, production lines and warehouses." },
      { name: "Logistics", desc: "Reliable coverage across warehouses, yards and transport operations." },
      { name: "Mining", desc: "Mission-critical systems for extreme environments and remote sites." },
      { name: "Private security", desc: "Surveillance and rapid-response teams always connected." },
      { name: "Hospitality", desc: "Discreet communication across departments for excellent service." },
      { name: "Utilities", desc: "Critical infrastructure with secure trunked radio networks." },
      { name: "Events", desc: "Staff and production coordination across large venues." },
    ],
    es: [
      { name: "Industria", desc: "Comunicación robusta en fábricas, líneas de producción y almacenes." },
      { name: "Logística", desc: "Cobertura fiable en almacenes, patios y operaciones de transporte." },
      { name: "Minería", desc: "Sistemas críticos en entornos extremos y sitios remotos." },
      { name: "Seguridad privada", desc: "Equipos de vigilancia y respuesta rápida siempre conectados." },
      { name: "Hotelería", desc: "Comunicación discreta entre departamentos para un servicio excelente." },
      { name: "Servicios públicos", desc: "Infraestructura crítica con redes trunked seguras." },
      { name: "Eventos", desc: "Coordinación de staff y producción en grandes recintos." },
    ],
  },
  why: {
    pt: {
      title: "Porquê escolher a Motorola Solutions?",
      items: [
        "Sistemas MOTOTRBO fiáveis e escaláveis",
        "Rádios certificados para ambientes exigentes",
        "Interoperabilidade IP e trunking avançado",
        "Suporte técnico e instalação em Angola",
        "Líder global em comunicação crítica",
      ],
    },
    en: {
      title: "Why choose Motorola Solutions?",
      items: [
        "Reliable, scalable MOTOTRBO systems",
        "Radios certified for demanding environments",
        "IP interoperability and advanced trunking",
        "Local technical support and installation in Angola",
        "Global leader in mission-critical communication",
      ],
    },
    es: {
      title: "¿Por qué elegir Motorola Solutions?",
      items: [
        "Sistemas MOTOTRBO fiables y escalables",
        "Radios certificados para entornos exigentes",
        "Interoperabilidad IP y trunking avanzado",
        "Soporte técnico e instalación en Angola",
        "Líder global en comunicación crítica",
      ],
    },
  },
  groups: [
    {
      id: "repeaters",
      icon: "antenna",
      title: {
        pt: "Repetidores MOTOTRBO",
        en: "MOTOTRBO Repeaters",
        es: "Repetidores MOTOTRBO",
      },
      description: {
        pt: "Amplie o alcance da sua rede de rádio digital com repetidores MOTOTRBO da série SLR — da solução compacta para eliminar zonas mortas até equipamento de alta performance para ambientes críticos.",
        en: "Extend the reach of your digital radio network with MOTOTRBO SLR repeaters — from compact units that eliminate dead zones to high-performance equipment for critical environments.",
        es: "Amplía el alcance de tu red de radio digital con repetidores MOTOTRBO de la serie SLR — desde soluciones compactas para eliminar zonas muertas hasta equipos de alto rendimiento para entornos críticos.",
      },
      products: [
        {
          slug: "slr-1000",
          pt: "MOTOTRBO SLR 1000 — Repetidor compacto para estender cobertura em zonas mortas e locais remotos",
          en: "MOTOTRBO SLR 1000 — Compact repeater that extends coverage across dead zones and remote locations",
          es: "MOTOTRBO SLR 1000 — Repetidor compacto para extender cobertura en zonas muertas y sitios remotos",
        },
        {
          slug: "slr-5500",
          pt: "MOTOTRBO SLR 5500 — Repetidor de alta performance, baixo consumo e formato rack sofisticado",
          en: "MOTOTRBO SLR 5500 — High-performance repeater with sleek rack form factor and low power consumption",
          es: "MOTOTRBO SLR 5500 — Repetidor de alto rendimiento, bajo consumo y formato rack sofisticado",
        },
        {
          slug: "slr-8000",
          pt: "MOTOTRBO SLR 8000 — Repetidor robusto e otimizado para operações críticas exigentes",
          en: "MOTOTRBO SLR 8000 — Rugged repeater optimised for demanding mission-critical operations",
          es: "MOTOTRBO SLR 8000 — Repetidor robusto y optimizado para operaciones críticas exigentes",
        },
      ],
    },
    {
      id: "systems",
      icon: "network",
      title: {
        pt: "Sistemas Digitais MOTOTRBO",
        en: "MOTOTRBO Digital Systems",
        es: "Sistemas Digitales MOTOTRBO",
      },
      description: {
        pt: "Soluções de interligação IP e trunking digital que ampliam capacidade, cobertura e segurança da sua rede de rádio profissional.",
        en: "IP site-linking and digital trunking solutions that scale the capacity, coverage and security of your professional radio network.",
        es: "Soluciones de enlace IP y trunking digital que amplían capacidad, cobertura y seguridad de tu red de radio profesional.",
      },
      products: [
        {
          slug: "ip-site-connect",
          pt: "IP Site Connect — Interliga repetidores através da Internet/IP e estende a cobertura a múltiplos locais",
          en: "IP Site Connect — Links repeaters over the Internet/IP and extends coverage across multiple sites",
          es: "IP Site Connect — Enlaza repetidores por Internet/IP y extiende la cobertura a múltiples sitios",
        },
        {
          slug: "capacity-plus",
          pt: "Capacity Plus — Trunking digital escalável de sítio único para aumentar a capacidade do sistema",
          en: "Capacity Plus — Scalable single-site digital trunking that expands system capacity",
          es: "Capacity Plus — Trunking digital escalable de un solo sitio para aumentar la capacidad del sistema",
        },
        {
          slug: "capacity-plus-multi",
          pt: "Capacity Plus Multi-Site — Trunking digital escalável multi-sítio para cobertura e capacidade expandidas",
          en: "Capacity Plus Multi-Site — Scalable multi-site digital trunking for expanded coverage and capacity",
          es: "Capacity Plus Multi-Site — Trunking digital escalable multi-sitio para mayor cobertura y capacidad",
        },
        {
          slug: "capacity-max",
          pt: "Capacity Max — Sistema trunked seguro e altamente escalável para comunicações de missão crítica",
          en: "Capacity Max — Secure, highly scalable trunked radio system for mission-critical communications",
          es: "Capacity Max — Sistema trunked seguro y altamente escalable para comunicaciones de misión crítica",
        },
      ],
    },
    {
      id: "apx-portable",
      icon: "shield-alert",
      title: {
        pt: "APX P25 — Rádios Portáteis de Segurança Pública",
        en: "APX P25 — Public Safety Portable Radios",
        es: "APX P25 — Radios Portátiles de Seguridad Pública",
      },
      description: {
        pt: "Rádios portáteis P25 concebidos para missão crítica — áudio potente e nítido, design robusto e conectividade avançada para socorristas, polícia e segurança pública.",
        en: "P25 portable radios engineered for mission-critical use — loud and clear audio, rugged design and advanced connectivity for first responders, police and public safety.",
        es: "Radios portátiles P25 diseñados para misión crítica — audio potente y nítido, diseño robusto y conectividad avanzada para socorristas, policía y seguridad pública.",
      },
      products: [
        {
          slug: "apx-8000xe",
          pt: "APX 8000XE — Rádio portátil P25 flagship, todas as bandas, design reforçado",
          en: "APX 8000XE — Flagship P25 portable radio, all-band, reinforced design",
          es: "APX 8000XE — Radio portátil P25 insignia, todas las bandas, diseño reforzado",
        },
        {
          slug: "apx-8000",
          pt: "APX 8000 — Rádio portátil P25 multibanda com áudio de alta clareza",
          en: "APX 8000 — Multiband P25 portable radio with high-clarity audio",
          es: "APX 8000 — Radio portátil P25 multibanda con audio de alta claridad",
        },
        {
          slug: "apx-6000xe",
          pt: "APX 6000XE — Rádio portátil P25 robusto e compacto para ambientes extremos",
          en: "APX 6000XE — Rugged compact P25 portable for extreme environments",
          es: "APX 6000XE — Radio portátil P25 robusto y compacto para entornos extremos",
        },
        {
          slug: "apx-n50",
          pt: "APX N50 — Rádio portátil P25 de perfil fino com tecnologia de nova geração",
          en: "APX N50 — Thin-profile P25 portable with next-generation technology",
          es: "APX N50 — Radio portátil P25 de perfil fino con tecnología de nueva generación",
        },
        {
          slug: "apx-900",
          pt: "APX 900 — Rádio portátil P25 de banda única acessível para serviços governamentais",
          en: "APX 900 — Affordable single-band P25 portable for government services",
          es: "APX 900 — Radio portátil P25 de banda única accesible para servicios públicos",
        },
      ],
    },
    {
      id: "apx-mobile",
      icon: "siren",
      title: {
        pt: "APX P25 — Rádios Móveis de Segurança Pública",
        en: "APX P25 — Public Safety Mobile Radios",
        es: "APX P25 — Radios Móviles de Seguridad Pública",
      },
      description: {
        pt: "Rádios móveis P25 para viaturas — interoperabilidade, conectividade segura e instalação simplificada para frotas de missão crítica.",
        en: "P25 in-vehicle mobile radios — interoperability, secure connectivity and simplified installation for mission-critical fleets.",
        es: "Radios móviles P25 para vehículos — interoperabilidad, conectividad segura e instalación simplificada para flotas críticas.",
      },
      products: [
        {
          slug: "apx-8500",
          pt: "APX 8500 — Rádio móvel P25 de todas as bandas com interoperabilidade total",
          en: "APX 8500 — All-band P25 mobile radio with full interoperability",
          es: "APX 8500 — Radio móvil P25 de todas las bandas con interoperabilidad total",
        },
        {
          slug: "apx-5500",
          pt: "APX 5500 — Rádio móvel P25 de banda única com comunicação segura",
          en: "APX 5500 — Single-band P25 mobile radio with secure communication",
          es: "APX 5500 — Radio móvil P25 de banda única con comunicación segura",
        },
        {
          slug: "apx-2500",
          pt: "APX 2500 — Rádio móvel P25 para eficiência operacional e fiabilidade",
          en: "APX 2500 — P25 mobile radio for operational efficiency and reliability",
          es: "APX 2500 — Radio móvil P25 para eficiencia operativa y fiabilidad",
        },
        {
          slug: "apx-1500",
          pt: "APX 1500 — Rádio móvel P25 de banda única acessível e confiável",
          en: "APX 1500 — Affordable and reliable single-band P25 mobile radio",
          es: "APX 1500 — Radio móvil P25 de banda única accesible y fiable",
        },
      ],
    },
    {
      id: "mototrbo-portable",
      icon: "headphones",
      title: {
        pt: "Rádios Portáteis MOTOTRBO",
        en: "MOTOTRBO Portable Radios",
        es: "Radios Portátiles MOTOTRBO",
      },
      description: {
        pt: "Rádios portáteis digitais MOTOTRBO — do modelo acessível ao rádio inteligente Ion, com opções para ambientes explosivos (ATEX) e uso discreto.",
        en: "MOTOTRBO digital portable radios — from affordable models to the Ion smart radio, including ATEX-certified and slim discreet options.",
        es: "Radios portátiles digitales MOTOTRBO — desde modelos accesibles hasta el radio inteligente Ion, con opciones ATEX y discretas.",
      },
      products: [
        {
          slug: "mototrbo-r2",
          pt: "MOTOTRBO R2 — Rádio portátil digital acessível, simples e robusto",
          en: "MOTOTRBO R2 — Affordable, simple and robust digital portable radio",
          es: "MOTOTRBO R2 — Radio portátil digital accesible, simple y robusto",
        },
        {
          slug: "mototrbo-r5",
          pt: "MOTOTRBO R5 — Rádio portátil digital com áudio claro e ergonomia compacta",
          en: "MOTOTRBO R5 — Digital portable radio with clear audio and compact ergonomics",
          es: "MOTOTRBO R5 — Radio portátil digital con audio claro y ergonomía compacta",
        },
        {
          slug: "mototrbo-r7",
          pt: "MOTOTRBO R7 — Rádio portátil digital premium com áudio avançado",
          en: "MOTOTRBO R7 — Premium digital portable radio with advanced audio",
          es: "MOTOTRBO R7 — Radio portátil digital premium con audio avanzado",
        },
        {
          slug: "mototrbo-r7ex",
          pt: "MOTOTRBO R7Ex — Rádio portátil digital certificado ATEX para ambientes explosivos",
          en: "MOTOTRBO R7Ex — ATEX-certified digital portable radio for explosive environments",
          es: "MOTOTRBO R7Ex — Radio portátil digital con certificación ATEX para entornos explosivos",
        },
        {
          slug: "mototrbo-ion",
          pt: "MOTOTRBO Ion — Rádio inteligente com voz crítica e dados em banda larga",
          en: "MOTOTRBO Ion — Smart radio with mission-critical voice and broadband data",
          es: "MOTOTRBO Ion — Radio inteligente con voz crítica y datos de banda ancha",
        },
        {
          slug: "dep-450",
          pt: "DEP 450 — Rádio portátil analógico/digital prático e acessível",
          en: "DEP 450 — Practical and affordable analog/digital portable radio",
          es: "DEP 450 — Radio portátil analógico/digital práctico y accesible",
        },
        {
          slug: "dep-500e",
          pt: "DEP 500e — Rádio portátil digital intermédio para pequenas e médias empresas",
          en: "DEP 500e — Mid-range digital portable radio for SMB organisations",
          es: "DEP 500e — Radio portátil digital intermedio para pymes",
        },
        {
          slug: "dgp-8550ex",
          pt: "DGP 8550EX — Rádio portátil certificado para ambientes explosivos",
          en: "DGP 8550EX — Portable radio certified for explosive environments",
          es: "DGP 8550EX — Radio portátil certificado para entornos explosivos",
        },
        {
          slug: "sl-500e",
          pt: "SL 500e — Rádio portátil fino e discreto para comunicação elegante",
          en: "SL 500e — Slim, discreet portable radio for elegant communication",
          es: "SL 500e — Radio portátil fino y discreto para comunicación elegante",
        },
      ],
    },
    {
      id: "mototrbo-mobile",
      icon: "truck",
      title: {
        pt: "Rádios Móveis MOTOTRBO",
        en: "MOTOTRBO Mobile Radios",
        es: "Radios Móviles MOTOTRBO",
      },
      description: {
        pt: "Rádios móveis digitais MOTOTRBO para viaturas — eficiência e produtividade em frotas, com visor numérico ou alfanumérico conforme a necessidade operacional.",
        en: "MOTOTRBO digital mobile radios for vehicles — efficiency and productivity across fleets, with numeric or alphanumeric displays to match operational needs.",
        es: "Radios móviles digitales MOTOTRBO para vehículos — eficiencia y productividad en flotas, con pantalla numérica o alfanumérica según la necesidad operativa.",
      },
      products: [
        {
          slug: "dem-300",
          pt: "DEM 300 — Rádio móvel analógico/digital com visor numérico",
          en: "DEM 300 — Analog/digital mobile radio with numeric display",
          es: "DEM 300 — Radio móvil analógico/digital con pantalla numérica",
        },
        {
          slug: "dem-400",
          pt: "DEM 400 — Rádio móvel analógico/digital com visor numérico e teclado",
          en: "DEM 400 — Analog/digital mobile radio with numeric display and keypad",
          es: "DEM 400 — Radio móvil analógico/digital con pantalla numérica y teclado",
        },
        {
          slug: "dem-500",
          pt: "DEM 500 — Rádio móvel digital com visor alfanumérico para maior controlo",
          en: "DEM 500 — Digital mobile radio with alphanumeric display for enhanced control",
          es: "DEM 500 — Radio móvil digital con pantalla alfanumérica para mayor control",
        },
      ],
    },
  ],
};
